import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, FlaskConicalIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Chip } from '../Chip';
import { TestimonialCard } from '../TestimonialCard';
import { testimonials } from '../../data/programa';
const reassurances = [{
  label: 'Garantía 7 días',
  icon: ShieldCheckIcon
}, {
  label: 'Pago seguro',
  icon: LockIcon
}, {
  label: 'Mercado Pago',
  icon: CreditCardIcon
}];
const stats = [{
  value: '+1.200',
  label: 'Profesionales aplicándolo'
}, {
  value: '6 Tomos',
  label: 'Listos para aplicar'
}, {
  value: '6 Bonos',
  label: 'Incluidos siempre'
}, {
  value: '4.75/5',
  label: 'Calificación'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative overflow-hidden border-b border-line bg-ink" data-id="element-153" data-mp="15l1tfswwudl1">
      <div className="radial-gold absolute inset-0" aria-hidden="true" data-id="element-154" data-mp="1ajmntbphe31k" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" aria-hidden="true" data-id="element-155" data-mp="1ahijwtrl141a" />

      <div className="relative mx-auto max-w-content px-6 py-16 lg:px-10 lg:py-20" data-id="element-156" data-mp="4o6mpojyd38k">
        <nav className="mb-14 flex justify-center" aria-label="Principal" data-id="element-157" data-mp="3vv12ksjbgc9p">
          <span className="inline-flex items-center gap-2.5 text-[14px] font-bold uppercase leading-none tracking-[0.22em] text-ice" data-id="element-158" data-mp="3vx3ob0dfrj8m">
            <FlaskConicalIcon className="h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-159" data-mp="se0vnv15i7nj" />
            DigiLab<span className="text-gold" data-id="element-160" data-mp="nexskg4qebi7">&nbsp;Academy</span>
          </span>
        </nav>

        <div className="mx-auto max-w-4xl text-center" data-id="element-161" data-mp="inz6t10z4l7k">
          <motion.h1 className="text-[36px] font-bold leading-[1.05] tracking-[-0.02em] text-ice sm:text-[52px] lg:text-[60px]" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease
        }} data-id="element-162" data-mp="imecncikn4a8">
            Llegá a las 17:00{' '}
            <span className="text-gold-sheen" data-id="element-163" data-mp="30lnoeolvy7s2">
              igual que llegaste a las 9:00
            </span>
          </motion.h1>

          <motion.div className="relative mt-10" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease
        }} data-id="element-164" data-mp="35kgz699sfkoj">
            <div className="absolute inset-x-6 top-[12%] h-[76%] rounded-[40px] bg-gold/20 blur-[70px] sm:inset-x-16" aria-hidden="true" data-id="element-165" data-mp="2huwhruta8vhd" />
            <img src="https://cdn.magicpatterns.com/uploads/uWgE6sbajMDn6Rb5LnNjtq/Megapack_2.png" alt="Mega Pack Atleta Corporativo: 6 tomos y 6 bonos" className="relative mx-auto w-full max-w-3xl rounded-2xl shadow-[0_0_60px_rgba(255,159,28,0.22)]" width={1536} height={1024} data-id="element-166" data-mp="2mw3p5srijsni" />
          </motion.div>

          <motion.p className="mx-auto mt-8 max-w-2xl text-[17px] leading-[1.7] text-ice [text-shadow:0_0_18px_rgba(203,213,225,0.35),0_0_40px_rgba(148,163,184,0.22)] sm:text-[18px]" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease
        }} data-id="element-167" data-mp="66oh2umff1aq">
            El programa que optimiza tu energía, foco y rendimiento durante toda
            tu jornada laboral.
          </motion.p>

          <motion.div className="mt-7" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.16,
          ease
        }} data-id="element-168" data-mp="20kaj9hqd4kpz">
            <Chip glow data-id="element-169" data-mp="2oamxfac7bdp0">Sistema N°1 de Biohacking Corporativo</Chip>
          </motion.div>

          <motion.div className="mx-auto mt-10 max-w-md" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.2,
          ease
        }} data-id="element-170" data-mp="2jcbk2pmp6l21">
            <CTAButton pulse data-id="element-171" data-mp="qfr6vd02vlpk">Quiero mi programa ahora</CTAButton>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[13px] text-cool" data-id="element-172" data-mp="qfhgvpf19ejv">
              {reassurances.map(item => <li key={item.label} className="inline-flex items-center gap-2" data-id="element-173" data-mp="10e6ompd7time">
                  <item.icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-174" data-mp="10c2p0jmcn5rx" />
                  {item.label}
                </li>)}
            </ul>
          </motion.div>

          <motion.dl className="mx-auto mt-14 grid max-w-2xl grid-cols-2 gap-x-6 gap-y-8 border-t border-line pt-10 text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.26,
          ease
        }} data-id="element-175" data-mp="7qt0ngrhvxef">
            {stats.map(stat => <div key={stat.label} data-id="element-176" data-mp="3l4o0mhn5za7h">
                <dt className="sr-only" data-id="element-177" data-mp="3l3mla0z481jy">{stat.label}</dt>
                <dd data-id="element-178" data-mp="3q2pg6sldsre7">
                  <span className="block text-3xl font-bold tracking-tight text-gold" data-id="element-179" data-mp="3q27cxc0axcws">
                    {stat.value}
                  </span>
                  <span className="mt-1.5 block text-[12px] uppercase tracking-[0.1em] text-cool" data-id="element-180" data-mp="275s2qehjptt3">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </motion.dl>
        </div>

        <motion.div className="mt-16 grid gap-6 lg:grid-cols-3" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.32,
        ease
      }} data-id="element-181" data-mp="1t8v0zhzw2rxf">
          {testimonials.map(testimonial => <TestimonialCard key={testimonial.name} testimonial={testimonial} data-id="element-182" data-mp="1fgoxowhu4ffe" />)}
        </motion.div>
      </div>
    </header>;
}